import { render, staticRenderFns } from "./Preasignaciones.vue?vue&type=template&id=486bd144&"
import script from "./Preasignaciones.vue?vue&type=script&lang=js&"
export * from "./Preasignaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports